import { useContext } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { AppContext } from 'core/context/app.context';
import { FeatureFlag } from 'core/enums/feature-flag';
import { LiveChat } from './live-chat';
import { LiveChatIFrame } from './live-chat-iframe';
import { LiveChatLegacy } from './live-chat-legacy';
import { LiveChatLegacyStore } from './live-chat-legacy.store';
import { LiveChatStore } from './live-chat.store';

export const LiveChatWrapper = observer(({ shouldOpen }: { shouldOpen?: boolean }) => {
  const { featureStore } = useContext(AppContext);
  const hasLegacyFlag = featureStore.hasViewPermission(FeatureFlag.LiveChatLegacy);
  const hasIFrameFlag = featureStore.hasViewPermission(FeatureFlag.LiveChatIFrame);
  const liveChatStore = useLocalObservable(() => (hasLegacyFlag ? new LiveChatLegacyStore() : new LiveChatStore()));

  const liveChatToDisplay = () => {
    if (hasIFrameFlag) {
      return <LiveChatIFrame store={liveChatStore as LiveChatStore} shouldOpen={shouldOpen} />;
    }

    if (hasLegacyFlag) {
      return <LiveChatLegacy store={liveChatStore} shouldOpen={shouldOpen} />;
    }

    return <LiveChat store={liveChatStore} shouldOpen={shouldOpen} />;
  };

  return liveChatToDisplay();
});